import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { MasterDataService } from '../../Services/MasterDataService';

@Component({
    selector: 'WelcomeScreen',
    templateUrl: './WelcomeScreen.html',
})

export class WelcomeScreen extends BaseComponent implements OnInit {
    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit(): void {
    }
}
